import PropTypes from "prop-types"
import { Select, Checkbox } from "components/ui"
import { Box } from "@planningcenter/tapestry-react"

const AttendeeRestrictionSelector = ({
  hasAttendeeRestriction = false,
  attendeeTypes,
  onCheckboxChange,
  onAttendeeRestrictionChange
}) => {
  return (
    <>
      <Select
        name="attendeeRestriction"
        className="select"
        id="attendeeRestriction"
        options={[
          { label: "All selections", value: "false" },
          { label: "Only certain selections", value: "true" }
        ]}
        value={hasAttendeeRestriction.toString()}
        onChange={onAttendeeRestrictionChange}
      />
      <Box paddingTop={1} css={{ wordBreak: "break-all" }}>
        {hasAttendeeRestriction &&
          attendeeTypes.map(at => (
            <div key={at.id}>
              <Checkbox
                name={`attendeeRestriction_${at.id}`}
                htmlFor={`attendeeRestriction_${at.id}`}
                text={`${at.name} ${
                  at.signupTime?.contextualDateTime ? `(${at.signupTime.contextualDateTime})` : ""
                }`}
                value={at.id.toString()}
                checked={at.isAvailable}
                onSelect={onCheckboxChange}
              />
            </div>
          ))}
      </Box>
    </>
  )
}

AttendeeRestrictionSelector.propTypes = {
  hasAttendeeRestriction: PropTypes.bool,
  attendeeTypes: PropTypes.array,
  onCheckboxChange: PropTypes.func,
  onAttendeeRestrictionChange: PropTypes.func
}

export default AttendeeRestrictionSelector
